import { SupplierOrderAnalytics } from './WinkhausOrderAnalytics';

const SchucoOrderAnalytics = () => <SupplierOrderAnalytics supplier="schuco" />;

export default SchucoOrderAnalytics;
